// const HOST = "http://localhost:9292/api/v1/proposals_public";

const HOST = "https://app.topbroker.lt/api/v1/proposals_public";

export { HOST };
